function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29.8 17.4c0-0.8 0.2-1.6 0.6-2 0.4-0.4 1-0.6 1.6-0.6 0.6 0 1.2 0.2 1.6 0.6 0.4 0.4 0.6 1 0.6 2 0 0.8-0.2 1.6-0.6 2-0.4 0.4-0.8 0.6-1.6 0.6-0.6 0-1.2-0.2-1.6-0.6-0.4-0.4-0.6-1-0.6-2z m4.2 32.4h-3.8v-25.4h3.8v25.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeMiterlimit: 10,
  d: "M21.26 6.14a28 28 0 1 0 21.54 51.68 28 28 0 1 0-21.54-51.68z"
}));

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.2acdcbec.svg";
export { ForwardRef as ReactComponent };